import * as Yup from 'yup';

const PUCLoginSchema = Yup.object({
  email: Yup.string().email('Invalid email address').required('Required'),
  password: Yup.string().required('Please enter your password'),
  park: Yup.string().required('Please select a park'),
});
export default PUCLoginSchema;
